import React, { useState, useEffect } from "react";
import IconButton from "@material-ui/core/IconButton";
import { StyledButton, StyledMenu, StyledMenuItem } from "pages/underwriters/components/allClientsTable/styles.js";
import { generatePGA } from "../../../../api/external_data";
import VerticalThreeDots from "assets/dashboardIcons/verticalThreeDots";
import { useHistory, useLocation } from "react-router-dom";
import { SuccessPopup } from "./SuccessPopup";
import { AlertMessage } from "./alertMessage";
import { LoadingMessage } from "./loadingMessage";
import { useSelector, useDispatch } from "react-redux";
import { entityCreditsSelector } from "data/selectors/user";
import { getEntityCredits, setEntityCredits } from "data/actions/user";
import { contactSelector } from "data/selectors/contact";
import { getContact } from "data/actions/contact";
import functionalCreditCosts from "../../../underwriterDashboard/functionalCreditCosts.json";
import InsufficientCreditsPopup from "../insufficientCreditsPopup";

export const ActionsMenuForPGA = ({ client_id, companyName, status, setData, viewPeerGroupAnalysis }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const history = useHistory();
  const location = useLocation();
  const [openSuccessPopup, setOpenSuccessPopup] = useState(false);
  const [notSuccessPopup, setNotSuccessPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showInsufficientCreditsPopup, setShowInsufficientCreditsPopup] = useState(false);
  
  const dispatch = useDispatch();
  const entityCredits = useSelector(entityCreditsSelector);
  const contact = useSelector(contactSelector);

  useEffect(() => {
    if (entityCredits == null) {
      dispatch(getEntityCredits(null));
    }
  }, [entityCredits, dispatch]);

  useEffect(() => {
    if (!contact) {
      dispatch(getContact());
    }
  }, [dispatch, contact]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const viewPeerGroupAnalysisClientData = () => {
    history.push("/underwriter/client/peergroupanalysis", {
      company_name: companyName,
      account_id: client_id
    });
  };

  const generatePeerGroupAnalysisClientData = async () => {
    if (entityCredits < functionalCreditCosts.pga.generateInsights) {
      setShowInsufficientCreditsPopup(true);
      return;
    }

    setLoading(true);
    const data = {
      company_name: companyName,
      account_id: client_id
    };

    try {
      await generatePGA(data, onSuccessPGAData, onFailurPGAData);
    } catch (error) {
      setNotSuccessPopup(true);
    } finally {
      setLoading(false);
    }
  };

  const onSuccessPGAData = (res) => {
    setOpenSuccessPopup(true);
    dispatch(setEntityCredits({
      user_id: contact?.user_id || "",
      institution_id: contact?.user_access_control?.institution_id,
      updated_entity_credits: entityCredits - functionalCreditCosts.pga.generateInsights,
      deductible_credits: functionalCreditCosts.pga.generateInsights
    }, (response) => {
      console.log("response", response);
    }, () => {
      console.log("failed");
    }));
  };

  const onFailurPGAData = (res) => {
    setNotSuccessPopup(true);
  };

  if (["deleted"].includes(status)) {
    return <></>;
  } else {
    return (
      <>
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleClick}
          style={{ padding: 0 }}
        >
          <VerticalThreeDots />
        </IconButton>
        <StyledMenu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
        >
          <StyledMenuItem>
            <StyledButton width="180px" onClick={viewPeerGroupAnalysisClientData}>
              View Last PGA
            </StyledButton>
          </StyledMenuItem>

          <StyledMenuItem>
            <StyledButton
              width="180px"
              onClick={generatePeerGroupAnalysisClientData}
              disabled={loading} // Disable button when loading
            >
              Update PGA and Scores
            </StyledButton>
          </StyledMenuItem>
        </StyledMenu>

        <SuccessPopup
          setOpenPopup={setOpenSuccessPopup}
          openPopup={openSuccessPopup}
        />

        <AlertMessage
          openPopup={notSuccessPopup}
          setOpenPopup={setNotSuccessPopup}
          description="Sorry 😟, I couldn't find sufficient data in this account to generate any insights."
          isFormatIssue={false}
        />

        <LoadingMessage
          openPopup={loading}
          setOpenPopup={setLoading}
          description="Working on it ⏳"
          isFormatIssue={false}
        />

        <InsufficientCreditsPopup
          open={showInsufficientCreditsPopup}
          setOpen={setShowInsufficientCreditsPopup}
        />

      </>
    );
  }
};
